<div #fixedEl class="orgbrain-style bot-class" [class.hide]="!showContent">
  <div class="button-row-full mb-pixel-20 mt-pixel-20">
    <ng-content></ng-content>
  </div>
</div>
